var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGcn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#009B4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7439 6.54761V8.77975C14.7439 9.19068 15.0923 9.5238 15.5222 9.5238H17.8573M10.4628 9.5238H12.0196M10.4628 11.7559H15.133M10.4628 13.9881H15.133M16.6898 7.66368C16.3433 7.36739 15.9839 7.01597 15.7569 6.78774C15.6059 6.63586 15.3973 6.54761 15.1781 6.54761H9.29508C8.43532 6.54761 7.73835 7.21385 7.73834 8.0357L7.73828 16.9642C7.73828 17.7861 8.43525 18.4523 9.29501 18.4523L16.3004 18.4524C17.1601 18.4524 17.8571 17.7862 17.8571 16.9643L17.8573 9.07603C17.8573 8.88577 17.7814 8.70289 17.6433 8.56592C17.3878 8.31264 16.9613 7.89589 16.6898 7.66368Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGcn);
export default __webpack_public_path__ + "static/media/icon_gcn.217f7c6765010f33cc4ba714c8cb4bf7.svg";
export { ForwardRef as ReactComponent };